import {obtenerValorMapeadoEsp} from 'src/app/core/enums/tipo-parentesco.enum';
import {DateTimeService} from 'src/app/core/utils/datetime.service';
import {ComplementosModel} from './complementos.model';
import {DatosBasicos} from './datos-basicos.model';
import {Identidad} from './identidad.model';
import {Parentesco} from './parentesco.model';
import {
  agregarDocumentoRNEC,
  agregarDocumentosNoExigibles,
  mapearASolicitudDocumentos
} from './solicitud-documentos-mapper';
import {SolicitudTiposEnum} from './solicitud-tipos.enum';
import {ACMValidator} from '../../../acreditacion-cuota-monetaria/acm-validator';

export class Beneficiario extends ComplementosModel {
  public motivo?: any;
  public identidad = Identidad.instance();
  public datosBasicos = DatosBasicos.instance();
  public parentesco = Parentesco.instance();
  public discapacidad: boolean;
  public cm: any;

  static mapearDesdeFormularioAFT(solicitudTipo: SolicitudTiposEnum, obj: any, titular?: any) {
    const beneficiarioDto = Beneficiario.instance();
    beneficiarioDto.identidad = {
      tipo: obj['tipoDocumento'],
      numero: obj['numeroDocumento']
    };

    beneficiarioDto.datosBasicos = {
      primerNombre: obj['primerNombre'],
      segundoNombre: obj['segundoNombre'] || '',
      primerApellido: obj['apellido'],
      segundoApellido: obj['segundoApellido'] || '',
      fechaNacimiento: obj['fechaNacimiento'],
      edad: DateTimeService.calcularEdadMapper(obj['fechaNacimiento']),
      genero: obj['genero'],
      corregidos: obj['corregidos'] || false
    };

    beneficiarioDto.parentesco = {
      tipoParentesco: obj.parentescoPerCarg?.name || '',
      codigoParentesco: obtenerValorMapeadoEsp(obj.parentescoPerCarg?.name || '') || ''
    };

    beneficiarioDto.discapacidad = obj['discapacidad'] === 'true';
    const edad = DateTimeService.calcularEdadMapper(obj['fechaNacimiento']);
    const parentesco = obj.parentescoPerCarg?.name;

    let cmValido: any = false;
    const categoriaTitular = ACMValidator.obtenerCategoriaPorSalario(Number(titular.SalarioTrabajador));
    if (titular != null) {
      cmValido = ACMValidator.esAcreditacionCuotaMonetariaYCategoriaValida(
        categoriaTitular,
        edad,
        parentesco,
        titular.EstadoCivilTrabajador?.codigo,
        titular.HorasLabDiaTrabajador
      );
    }
    if (beneficiarioDto.discapacidad) {
      beneficiarioDto.cm = beneficiarioDto.discapacidad
    } else {
      beneficiarioDto.cm = cmValido;
    }

    let complementos = [];
    complementos = mapearASolicitudDocumentos(solicitudTipo, obj['documents'], beneficiarioDto.cm);

    if (obj['base64Valid']) {
      let esRnecParentesco = false;
      if (obj['esHijoValido']) {
        esRnecParentesco = (obj['parentescoPerCarg']['name'] == 'Hijo');
      }
      agregarDocumentoRNEC(solicitudTipo, obj['base64Valid'], complementos, esRnecParentesco);
    }

    agregarDocumentosNoExigibles(solicitudTipo, obj['documentsNoExigibles'], complementos);

    beneficiarioDto.complementos = complementos;
    return beneficiarioDto;
  }

  static mapearDesdeFormularioNCM(solicitudTipo: SolicitudTiposEnum, obj: any, titular?: any) {
    const beneficiarioDto = Beneficiario.instance();
    beneficiarioDto.identidad = {
      tipo: obj['tipoDocumento'],
      numero: obj['numeroDocumento']
    };

    beneficiarioDto.datosBasicos = {
      primerNombre: obj['primerNombre'],
      segundoNombre: obj['segundoNombre'] || '',
      primerApellido: obj['apellido'],
      segundoApellido: obj['segundoApellido'] || '',
      fechaNacimiento: obj['fechaNacimiento'],
      edad: DateTimeService.calcularEdadMapper(obj['fechaNacimiento']),
      genero: obj['genero']
    };

    beneficiarioDto.parentesco = {
      tipoParentesco: obj.parentescoPerCarg?.name || '',
      codigoParentesco: obtenerValorMapeadoEsp(obj.parentescoPerCarg?.name || '') || ''
    };

    beneficiarioDto.discapacidad = obj['discapacidad'] === 'true';
    let cmValido: any = false;
    let complementos = [];
    complementos = mapearASolicitudDocumentos(solicitudTipo, obj['documents'], cmValido);
    if (obj['base64Valid']) {
      let esRnecParentesco = false;
      if (obj['esHijoValido']) {
        esRnecParentesco = (obj['parentescoPerCarg']['name'] == 'Hijo');
      }
      agregarDocumentoRNEC(solicitudTipo, obj['base64Valid'], complementos, esRnecParentesco);
    }
    agregarDocumentosNoExigibles(solicitudTipo, obj['documentsNoExigibles'], complementos);
    beneficiarioDto.complementos = complementos;
    return beneficiarioDto;
  }

  static mapearDesdeFormularioND(solicitudTipo: SolicitudTiposEnum, obj: any, titular?: any) {
    const beneficiarioDto = Beneficiario.instance();
    beneficiarioDto.identidad = {
      tipo: obj['tipoDocumento'],
      numero: obj['numeroDocumento']
    };

    beneficiarioDto.datosBasicos = {
      primerNombre: obj['primerNombre'],
      segundoNombre: obj['segundoNombre'] || '',
      primerApellido: obj['apellido'],
      segundoApellido: obj['segundoApellido'] || '',
      fechaNacimiento: obj['fechaNacimiento'],
      edad: DateTimeService.calcularEdadMapper(obj['fechaNacimiento']),
      genero: obj['genero']
    };

    beneficiarioDto.parentesco = {
      tipoParentesco: obj.parentescoPerCarg?.name || '',
      codigoParentesco: obtenerValorMapeadoEsp(obj.parentescoPerCarg?.name || '') || ''
    };

    beneficiarioDto.discapacidad = true;
    beneficiarioDto.cm = obj['rangoC'] !== undefined ? !obj['rangoC'] : false;

    let complementos = [];
    complementos = mapearASolicitudDocumentos(solicitudTipo, obj['documents'], beneficiarioDto.cm);

    if (obj['base64Valid']) {
      const esRnecParentesco = (obj['parentescoPerCarg']['name'] == 'hijo');
      agregarDocumentoRNEC(solicitudTipo, obj['base64Valid'], complementos, esRnecParentesco);
    }

    agregarDocumentosNoExigibles(solicitudTipo, obj['documentsNoExigibles'], complementos);

    beneficiarioDto.complementos = complementos;
    return beneficiarioDto;
  }

  static mapearDesdeFormularioRIB(solicitudTipo: SolicitudTiposEnum, obj: any, motivo: any, formDocuments: any) {
    const beneficiarioDto = Beneficiario.instance();
    beneficiarioDto.motivo = motivo.toString();
    beneficiarioDto.identidad = {
      tipo: obj['tipoDocumento'],
      numero: obj['numeroDocumento']
    };

    beneficiarioDto.datosBasicos = {
      primerNombre: obj['primerNombre'].toLocaleUpperCase(),
      segundoNombre: obj['segundoNombre'].toLocaleUpperCase() || '',
      primerApellido: obj['apellido'].toLocaleUpperCase(),
      segundoApellido: obj['segundoApellido'].toLocaleUpperCase() || '',
      fechaNacimiento: DateTimeService.quitarHora(obj['fechaNacimiento']),
      edad: DateTimeService.calcularEdad(obj['fechaNacimiento']),
      genero: obj['genero']
    };

    beneficiarioDto.discapacidad = false;
    beneficiarioDto.cm = false
    beneficiarioDto.cm = obj['rangoC'] !== undefined ? !obj['rangoC'] : false;
    beneficiarioDto.parentesco = {
      tipoParentesco: obj['relacion']['descripcion'],
      codigoParentesco: obj['relacion']['codigo']
    };
    const crearComplementoVacio =
      !formDocuments.documents ||
      formDocuments.documents === 0 ||
      (typeof formDocuments.documents === 'object' &&
        Object.keys(formDocuments.documents).length === 0);
    beneficiarioDto.complementos = mapearASolicitudDocumentos(solicitudTipo, formDocuments['documents'], false, crearComplementoVacio);
    return beneficiarioDto;
  }

  static mapearDesdeFormularioRITBF(solicitudTipo: SolicitudTiposEnum, objs: any[]) {
    const beneficiarios: any[] = [];

    for (const obj of objs) {
      const beneficiarioDto = Beneficiario.instance();

      // Identidad
      beneficiarioDto.identidad = {
        tipo: obj['tipoDocumento'],
        numero: obj['numeroDocumento']
      };

      // Datos básicos
      beneficiarioDto.datosBasicos = {
        primerNombre: obj['primerNombre'],
        segundoNombre: obj['segundoNombre'] || '',
        primerApellido: obj['apellido'],
        segundoApellido: obj['segundoApellido'] || '',
        fechaNacimiento: obj['fechaNacimiento'],
        edad: DateTimeService.calcularEdad(obj['fechaNacimiento']),
        genero: obj['genero']
      };

      // Parentesco
      const tipoParentesco = obj.parentescoPerCarg?.name || '';
      beneficiarioDto.parentesco = {
        tipoParentesco,
        codigoParentesco: obtenerValorMapeadoEsp(tipoParentesco) || ''
      };

      // Discapacidad: Se corrige para aceptar "1" como verdadero
      beneficiarioDto.discapacidad = obj['discapacidad'] === '1';

      // CM: Se invierte rangoC si viene definido
      beneficiarioDto.cm = obj['rangoC'] !== undefined ? !obj['rangoC'] : false;

      // Complementos - documentos exigibles
      let complementos = mapearASolicitudDocumentos(solicitudTipo, obj['documents'], beneficiarioDto.cm);

      // Documento RNEC si hay base64
      if (obj['base64Valid']) {
        const esRnecParentesco = obj['parentescoPerCarg']?.name?.toLowerCase() === 'hijo';
        agregarDocumentoRNEC(solicitudTipo, obj['base64Valid'], complementos, esRnecParentesco);
      }

      // Documentos no exigibles
      agregarDocumentosNoExigibles(solicitudTipo, obj['documentsNoExigibles'], complementos);

      // Asignar complementos
      beneficiarioDto.complementos = complementos;

      // Agregar a la lista final
      beneficiarios.push(beneficiarioDto);
    }

    return beneficiarios;
  }

  static mapearDesdeFormularioDiscp(solicitudTipo: SolicitudTiposEnum, objs: any[]) {
    const beneficiarios: any[] = [];

    for (const obj of objs) {
      const beneficiarioDto = Beneficiario.instance();

      // Identidad
      beneficiarioDto.identidad = {
        tipo: obj['tipoDocumento'],
        numero: obj['numeroDocumento']
      };

      // Datos básicos
      beneficiarioDto.datosBasicos = {
        primerNombre: obj['primerNombre'],
        segundoNombre: obj['segundoNombre'] || '',
        primerApellido: obj['apellido'],
        segundoApellido: obj['segundoApellido'] || '',
        fechaNacimiento: DateTimeService.quitarHora(obj['fechaNacimiento']),
        edad: DateTimeService.calcularEdad(obj['fechaNacimiento']),
        genero: obj['genero']
      };

      // Parentesco
      const tipoParentesco = obj.parentescoPerCarg?.name || '';
      beneficiarioDto.parentesco = {
        tipoParentesco,
        codigoParentesco: obtenerValorMapeadoEsp(tipoParentesco) || ''
      };

      // Discapacidad: Se corrige para aceptar "1" como verdadero
      beneficiarioDto.discapacidad = obj['discapacidad'] === '1';

      // CM: Se invierte rangoC si viene definido
      beneficiarioDto.cm = obj['rangoC'] !== undefined ? !obj['rangoC'] : false;

      // Complementos - documentos exigibles
      let complementos = mapearASolicitudDocumentos(solicitudTipo, obj['documents'], beneficiarioDto.cm);

      // Documento RNEC si hay base64
      if (obj['base64Valid']) {
        const esRnecParentesco = obj['parentescoPerCarg']?.name?.toLowerCase() === 'hijo';
        agregarDocumentoRNEC(solicitudTipo, obj['base64Valid'], complementos, esRnecParentesco);
      }

      // Documentos no exigibles
      agregarDocumentosNoExigibles(solicitudTipo, obj['documentsNoExigibles'], complementos);

      // Asignar complementos
      beneficiarioDto.complementos = complementos;

      // Agregar a la lista final
      beneficiarios.push(beneficiarioDto);
    }

    return beneficiarios;
  }

  public static instance() {
    return new this();
  }
}
